import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import pmpApplication from '../../../../../menu-items/pmp-application';
// material-ui
import { makeStyles } from '@material-ui/styles';
import { Divider, List, Typography } from '@material-ui/core';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import useAuth from 'hooks/useAuth';
import { SET_ACTIVE_MENU_ID } from 'store/actions';

// style constant
const useStyles = makeStyles((theme) => ({
    menuCaption: {
        ...theme.typography.menuCaption
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    menuDivider: {
        marginTop: '2px',
        marginBottom: '10px'
    }
}));

// ===========================|| SIDEBAR MENU LIST GROUP ||=========================== //

const mainMenuLevlesApplicable = ['1', '2', '3', '4', '5', '6', '7', '8'];
const utsavSankhyaNondaniAccess = ['3', '4', '5', '6', '7'];
const onlySuperAdminMainMenus = ['system-users'];
const onlySuperAdminMenus = ['unapproved-users-list'];

const prodSankalpAccessTo = [
    'pmpsangh@gmail.com',
    // BHAG - JILHA Users
    'moreshwar.gadre0102@gmail.com',
    'js_jayesh@hotmail.com',
    'yesanejotiba@gmail.com',
    'jinevam06@gmail.com',
    'vkota2774@gmail.com',
    'amitraut126@gmail.com',
    'vilaspawar19@gmail.com',
    'kulkarniraghven@gmail.com',
    'bindumadhav69@gmail.com',
    'katkeajinkya86@gmail.com',
    'javinashan@gmail.com',
    'amitraut126@gmail.com',
    'ambekarharshal@gmail.com',
    'akolkaryashvant@gmail.com',
    'narendrakul18@yahoo.in',
    'usureka@gmail.com',
    'rajendra.r.chavan@gmail.com',
    'katraj.bhag@gmail.com',
    'tulasi123dk@gmail.com',
    'muktman25@gmail.com',
    'thitesa17@GMAIL.COM',
    'mayur.rede@gmail.com',
    'deshpandesameer59@gmail.com',
    'ravinikam555@gmail.com',
    'kaleam76@yahoo.co.in',
    'vijaykhalkar88@gmail.com',
    'gawalinandu7@gmail.com',
    'sunil.g.patil1@gmail.com',
    'abhay.barahate@gmail.com',
    'mukunda.thombare@gmail.com',
    'dhananjay.randhavan@outlook.com',
    'raskar2atul@gmail.com ',
    'pss13262013@gmail. Com',
    'ashok.vagga7@gmail.com',
    'mahendraparanjpe@gmail.com',
    'jitmisar2012@gmail.com',
    'rohitkarus@gmail.com',
    'thakurvg07@gmail.com',
    'sandipkhadake5116@gmail.com'
];
const stagingSankalpAccessTo = ['kundanart1983+katrajbhag@gmail.com', 'prafulla@patheya.tech'];
const sankalpAccessToOnlyEmails = [...prodSankalpAccessTo, ...stagingSankalpAccessTo];

const NavGroup = ({ item }) => {
    const classes = useStyles();
    const { user } = useAuth();
    const location = useLocation();
    // const dispatch = useDispatch();
    // const currMenuId = useSelector((state) => state.sideBar);

    // Main menu list hidden option
    let filteredItems = item.children;
    let filteredMenus = filteredItems;

    const [items, setItems] = useState([]);
    const [activeMenuId, setActiveMenuId] = useState(filteredMenus?.id ?? null);

    // get menu id from url
    useEffect(() => {
        const getMenuId = pmpApplication?.children?.find(
            (i) => i?.url?.includes(location.pathname) || i?.children?.some((j) => j?.url?.includes(location.pathname))
        );
        setActiveMenuId(getMenuId?.id);
    }, [location.pathname]);

    // dispatch({ type: SET_ACTIVE_MENU_ID, menuId: filteredMenus.id });

    const filterMenus = () => {
        // No custom filtering needed for current menu items
        // This function is kept for future extensibility
    };

    useEffect(() => {
        if (user && user.profile && mainMenuLevlesApplicable.includes(user.profile.level.level_id) === false) {
            filteredItems = item.children.filter((m) => onlySuperAdminMainMenus.indexOf(m.id) < 0);
        }
        if (filteredMenus[0].type === 'collapse') {
            filterMenus();
            const newFilteredMenus = [];
            filteredMenus.forEach((i) => {
                let items = i;
                // if (i.id === 'sankalp' && user.profile.level.level_id === '1') {
                //     newFilteredMenus.push(i);
                //     return;
                // }
                // if (i.id === 'sankalp' && sankalpAccessToOnlyEmails.includes(user.email) === false) {
                //     return;
                // }

                // for level less than or equal to 3 utsav-sankhya-nondani menu will only be visible not for other levels
                if (+user.profile.level.level_id > 3) {
                    const updatedChildren = items?.children?.filter((item) => item?.id !== 'edit-system-user');
                    items = {
                        ...items,
                        children: updatedChildren
                    };
                }

                // if (i.id === 'utsav' && +user.profile.level.level_id > 7) return;
                if (items.id === 'utsav-sankhya-vrutta' && +user.profile.level.level_id > 5) return;

                // for level 6 and 7 utsav-sankhya-nondani menu will only be visible not for other levels
                if (items.id === 'utsav-sankhya-nondani' && !utsavSankhyaNondaniAccess.includes(user.profile.level.level_id)) return;

                newFilteredMenus.push(items);
            });
            filteredMenus = newFilteredMenus;
        }
        const tempItems = filteredMenus.map((menu) => {
            switch (menu.type) {
                case 'collapse':
                    return (
                        <NavCollapse key={menu?.id} menu={menu} level={1} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />
                    );
                case 'item':
                    return <NavItem key={menu.id} item={menu} level={1} />;
                default:
                    return (
                        <Typography key={menu.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });
        setItems(tempItems);
    }, [activeMenuId]);

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" className={classes.menuCaption} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider className={classes.menuDivider} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
